import { BigNumber } from 'bignumber.js';
export default BigNumber;
//# sourceMappingURL=BigNumber.js.map